import { render, staticRenderFns } from "./bottomMenu.vue?vue&type=template&id=7b4a0a82&"
import script from "./bottomMenu.vue?vue&type=script&lang=js&"
export * from "./bottomMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports